import { gql } from '@apollo/client';

export const GET_ORDER_REPRINT_LOGS = gql`
    query GetOrderReprintLogs(
        $hubId: Long
        $warehouseId: Long
        $startTime: Long
        $endTime: Long
        $accountId: Long
        $source: Int
        $page: Int!
        $size: Int!
    ) {
        getOrderReprintLogs(
            hubId: $hubId
            warehouseId: $warehouseId
            startTime: $startTime
            endTime: $endTime
            accountId: $accountId
            source: $source
            page: $page
            size: $size
        ) {
            content {
                id
                source
                neutralTrackingNumber
                reprintTrackingNumber
                trackingNumber
                status
                failureType
                failureReason
                processingTimeMs
                createdAt
            }
            totalElements
            page
            totalPages
        }
    }
`;

export interface OrderReprintLogItem {
    id: number;
    source: number;
    neutralTrackingNumber: string;
    reprintTrackingNumber?: string;
    trackingNumber?: string;
    status: 1 | 2;
    failureType?: number;
    failureReason?: string;
    processingTimeMs: number;
    createdAt: number;
}

export interface OrderReprintLogsResponse {
    getOrderReprintLogs: {
        content: OrderReprintLogItem[];
        totalElements: number;
        page: number;
        totalPages: number;
    };
}
